import { useThemeUI } from 'theme-ui'
import Hero from '../../elements/hero'
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import Breadcrumb from '../breadcrumb'
import Grid from '../grid/grid-from-json.connected'

const HeroBBDEals = ({ breadcrumbs, content, image, layout }) => {
  const imageEntity = useEntity(image)
  const imageUrl = image ? imageEntity.file?.url : null
  const theme = useThemeUI()
  const bottomImageOverflow = theme.theme.elements.hero?.bottomImageOverflow

  return (
    <Hero
      fgImage={imageUrl}
      breadcrumbs={breadcrumbs && <Breadcrumb {...breadcrumbs} />}
      bottomImageOverflow={bottomImageOverflow}
    >
      <div
        sx={{
          paddingBottom: bottomImageOverflow,
        }}
      >
        <Grid content={content} layout={layout} />
      </div>
    </Hero>
  )
}

export default HeroBBDEals
